<template>
  <div class="form-view">
    <div class="content-list-view">
      <el-form
        :model="ruleForm"
        :rules="rules"
        class="login-form"
        ref="registerForm"
        label-width="154px"
        style="width: 60%"
      >
        <el-form-item label="企业名称:" prop="entName">
          <el-select
            style="width: 100%"
            v-model="ruleForm.entName"
            filterable
            remote
            placeholder="请输入企业名称"
            no-data-text="您输入的企业不存在，请重新输入"
            :remote-method="remoteMethod"
            @change="entNameChange"
            :loading="entNameLoading"
            :disabled="true"
          >
            <el-option
              v-for="item in entNameList"
              :key="item.SHXYDM"
              :label="item.ENTNAME"
              :value="item.SHXYDM"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统一社会信用代码:" prop="socialCreditCode">
          <el-input
            v-model="ruleForm.socialCreditCode"
            placeholder="统一社会信用代码"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业属地:" prop="territory">
          <el-select
            style="width: 100%"
            v-model="ruleForm.territory"
            placeholder="请选择企业属地"
            :disabled="editState"
          >
            <el-option
              v-for="item in territoryOption"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人:" prop="cnname">
          <el-input
            v-model="ruleForm.cnname"
            maxlength="20"
            placeholder="请输入联系人"
            :disabled="editState"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话:" prop="mobile">
          <el-input
            :disabled="true"
            v-model="ruleForm.mobile"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业类型:" prop="entType">
          <el-select
            style="width: 100%"
            v-model="ruleForm.entType"
            placeholder="企业类型"
            collapse-tags
            :disabled="editState"
          >
            <el-option
              v-for="item in entTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产业:" prop="industry">
          <el-select
            style="width: 100%"
            v-model="ruleForm.industry"
            placeholder="请选择产业"
            multiple
            collapse-tags
            :disabled="editState"
          >
            <el-option
              v-for="item in industryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成长阶段:" prop="growthStage">
          <el-select
            style="width: 100%"
            v-model="ruleForm.growthStage"
            placeholder="请选择成长阶段"
            collapse-tags
            :disabled="editState"
          >
            <el-option
              v-for="item in growthStageList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业：" prop="business">
          <el-cascader
            style="width: 100%"
            v-model="ruleForm.business"
            :options="businessList"
            ref="industryCascader"
            :disabled="editState"
            :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id'
            }"
            @change="industryChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="营业收入:" prop="taking">
          <el-select
            style="width: 100%"
            v-model="ruleForm.taking"
            placeholder="请选择营业收入"
            :disabled="editState"
          >
            <el-option
              v-for="item in takingList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="`${industryKey[name].name}：`"
          v-for="(value, name) in optionList"
          :key="industryKey[name].value"
          :prop="industryKey[name].value"
        >
          <el-select
            :disabled="editState"
            v-model="ruleForm[industryKey[name].value]"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in value"
              :key="index"
              :label="item.optionValue"
              :value="item.optionCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业简介:">
          <el-input
            :disabled="editState"
            type="textarea"
            placeholder="请选择企业简介"
            v-model="ruleForm.enterpriseProfile"
            maxlength="300"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="control-view">
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        @click="editForm"
        v-if="editState"
      >
        编辑
      </el-button>
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        v-if="!editState"
        @click="saveInfo"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getEntByKeyword,
  getPhoneCode,
  // eslint-disable-next-line no-unused-vars
  getRegisterUserEdit,
  getIndustry,
  getList,
  getDropDown,
  getByToken2,
  getComSearch
} from "@/api/app";
export default {
  data() {
    const validatePhone = async (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    return {
      entNameList: [],
      entNameLoading: false,
      loading: false,
      ruleForm: {
        entName: "",
        socialCreditCode: "",
        cnname: "",
        mobile: "",
        entType: "",
        industry: [],
        growthStage: "", //成长阶段
        business: [],
        totalAssets: "",
        practitioner: "",
        taking: "",
        enterpriseProfile: "",
        territory: ""
      },
      entTypeList: [], // 企业类型
      industryList: [], // 产业
      growthStageList: [], //成长阶段
      businessList: [], //行业
      territoryOption: [],
      rules: {
        entName: [
          { required: true, message: "请输入企业名称", trigger: "change" }
        ],
        socialCreditCode: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: "change"
          }
        ],
        cnname: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        territory: [
          {
            required: true,
            message: "请选择企业属地",
            trigger: "change"
          }
        ],
        entType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: "change"
          }
        ],
        industry: [
          {
            required: true,
            message: "请选择产业",
            trigger: "change"
          }
        ],
        growthStage: [
          {
            required: true,
            message: "请选择成长阶段",
            trigger: "change"
          }
        ],
        business: [
          {
            required: true,
            message: "请选择行业",
            trigger: "change"
          }
        ],
        totalAssets: [
          { required: true, message: "请选择资产总额", trigger: "change" }
        ],
        practitioner: [
          { required: true, message: "请选择从业人员", trigger: "change" }
        ],
        taking: [
          { required: true, message: "请选择营业收入", trigger: "change" }
        ]
      },
      industryKey: {
        资产总额: { name: "资产总额（万元）", value: "totalAssets" },
        从业人员: { name: "从业人员（人）", value: "practitioner" },
        营业收入: { name: "营业收入（万元）", value: "taking" }
      },
      optionList: {},
      editState: true,
      entNameChangeValue: false,
      takingList: []
    };
  },
  beforeMount() {
    this.getByToken2();
  },
  mounted() {
    this.getIndustry();
    this.getDropDown("userIndustry", "industryList");
    this.getDropDown("growthStage", "growthStageList");
    this.getDropDown("entType2", "entTypeList");
    this.getDropDown("zczb", "takingList");
    this.getComSearch();
  },
  methods: {
    async getComSearch() {
      let { data } = await getComSearch({ type: 9 });
      this.territoryOption = data;
    },
    editForm() {
      this.editState = false;
    },
    async getByToken2() {
      let { data } = await getByToken2();
      let params = {};
      for (const key in this.ruleForm) {
        if (data[key]) {
          params[key] = data[key];
        }
      }
      params.industry = params.industry.split(",");
      params.business = params.business.split(",").map(Number);
      params.taking = params.taking ? params.taking + "" : "";
      params.practitioner = params.practitioner ? params.practitioner + "" : "";
      params.totalAssets = params.totalAssets ? params.totalAssets + "" : "";
      this.ruleForm = Object.assign({}, this.ruleForm, params);
      this.showIndustry();
    },
    async showIndustry() {
      let { business } = this.ruleForm;
      let { data } = await getList({ hyId: business.at(-1) });
      let listData = {};
      for (const key in data) {
        const element = data[key];
        if (key !== "营业收入") {
          listData[key] = element;
        }
      }
      this.optionList = listData;
    },
    /**企业模糊检索 */
    async remoteMethod(query) {
      if (query !== "") {
        this.entNameLoading = true;
        let { data } = await getEntByKeyword({ keyword: query });
        this.entNameLoading = false;
        let listKey = {};
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          listKey[element.SHXYDM] = element.ENTNAME;
        }
        this.entNameListKey = listKey;
        this.entNameList = data;
      } else {
        this.entNameList = [];
      }
    },
    entNameChange(item) {
      this.ruleForm.socialCreditCode = item;
      this.entNameChangeValue = true;
    },
    /**提交 */
    saveInfo() {
      this.$refs["registerForm"].validate(async valid => {
        if (valid) {
          this.loading = true;
          let params = Object.assign({}, this.ruleForm);
          if (this.entNameChangeValue) {
            params.entName = this.entNameListKey[params.socialCreditCode];
          }
          params.industry = params.industry ? params.industry.join(",") : "";
          params.business = params.business ? params.business.join(",") : "";
          getRegisterUserEdit(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.editState = true;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async mobileClick() {
      let phoneCode = /^1[3456789]\d{9}$/;
      if (!phoneCode.test(this.ruleForm.mobile)) {
        this.$message.error("请输入正确手机号");
      } else {
        let { data } = await getPhoneCode({
          phoneNumber: this.ruleForm.mobile,
          templateId: "SMS_247795134"
        });
        console.log(data);
        this.timeInterval = setInterval(() => {
          this.obtainCode = this.time_s + "S后重试";
          this.time_s--;
          if (this.time_s < 0) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.time_s = 60;
            this.obtainCode = "获取验证码";
          }
        }, 1000);
      }
    },
    async industryChange() {
      let { business } = this.ruleForm;
      console.log(business);
      let { data } = await getList({ hyId: business.at(-1) });
      this.ruleForm.totalAssets = "";
      this.ruleForm.practitioner = "";
      this.ruleForm.taking = "";
      let listData = {};
      for (const key in data) {
        const element = data[key];
        if (key !== "营业收入") {
          listData[key] = element;
        }
      }
      this.optionList = listData;
    },
    async getIndustry() {
      let { data } = await getIndustry();
      this.businessList = data;
    },
    /**下拉条件请求 */
    async getDropDown(type, option) {
      let { data } = await getDropDown({ type: type });

      this[option] = data;
    }
  }
};
</script>

<style lang="less" scoped>
.control-view {
  padding-left: 320px;
  & .el-button {
    background: rgba(41, 99, 204, 1);
    border-color: rgba(41, 99, 204, 1);
  }
}
</style>
